<template>
    <el-form :model="formData" v-bind="$attrs" @submit.native.prevent>
        <el-form-item required label="选择媒体">
            <el-radio-group v-model="formData.plat_id" @change="(val)=>handlePlatChange(val)">
                <el-radio-button 
                    v-for="item in platList" 
                    :label="item.value" 
                    :key="item.value"
                >
                    {{item.label}}
                </el-radio-button>
            </el-radio-group>
        </el-form-item>
    </el-form>
</template>

<script>
import { PLAT_TYPE } from './constant'
export default {
    props: [ 'platId', 'platList', 'defaultFormData' ],
    data() {
        return {
            formData:{ ...this.defaultFormData },
        }
    },
    methods: {
        async validateFn() {
            return { ...this.formData }
        },
        handlePlatChange(val) {
            this.$bus.$emit('validSelectData', (selectData, callback)=> {
                if (selectData.length) {
                     this.$confirm('切换媒体将清空筛选内容，是否继续?', '提示', {
                        confirmButtonText: '清空',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$emit('update:platId', val);
                        // 清空数据
                        callback()
                    }).catch(() => {
                        this.formData.plat_id =  this.platId; 
                    })
                }else {
                    callback()
                    this.$emit('update:platId', val)
                }
            });
           
        }
    }
}
</script>

<style lang="scss" scoped>

</style>